export function getError (error) {
  const body = error.response && error.response.body
  if (body && body.message) {
    return body
  } else if (body && body.errorMessage) {
    return { message: body.errorMessage }
  } else {
    return error
  }
}

export function getSchemaError(error) {
  const status = error.response?.status;
  if (status === 404) return "FORM_NOT_FOUND";
  else if (status === 401 || error.message === "LWB_NOT_ALLOWED") return "ACCESS_DENIED";
  else return "API_ERROR";
}
